import React, { useContext, useRef, useState } from "react";
import { IoMdSend } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { updateChat } from "../../Redux/reducers/chatSlice";
import { addLoadingMessage, addMessage } from "../../Redux/reducers/messagesSlice";
import { setIsSending, setSent } from "../../Redux/reducers/sendingSlice";
import { createNotification } from "../Common/CreateNotification";
import { SocketContext } from "../Context/ContextProvider";

export default function ChatMessagingBar({ seller, customer, activeTab }) {
  const [messageInput, setMessageInput] = useState("");
  // const [detectedLink, setDetectedLink] = useState(false);
  // const value = useDebouncedValue(messageInput, 1000);

  const inputRef = useRef(null);

  const socket = useContext(SocketContext)
  const dispatch = useDispatch();
  const currRole = useSelector((state) => state.chatRole.role);

  // sending message from socket ............................
  const handleClick = async () => {
    try {
      if (socket && messageInput !== "") {
        dispatch(setSent(false));
        dispatch(setIsSending(true));
        const outgoingMessage = {
          message: messageInput,
          seller_id: seller,
          customer_id: customer,
          position: currRole === "seller" ? "right" : "left",
        };
        socket.emit("message", outgoingMessage);

        dispatch(addMessage(outgoingMessage, seller, customer));
        dispatch(addLoadingMessage(outgoingMessage))
        const updateData = {
          message: messageInput,
          sellerId: seller,
          customerId: customer,
        };
        if (activeTab === "1") {
          dispatch(updateChat({ ...updateData, updateRequestedOn: "sellers" }));
        } else if (activeTab === "2") {
          dispatch(
            updateChat({ ...updateData, updateRequestedOn: "customers" })
          );
        }


        // setDetectedLink(false);
      } else {
        createNotification("warning", "Can't send empty message");
      }

      setMessageInput("");
    } catch (error) {
      createNotification("Error sending message", error);
    }
  };

  // sending typing status to the socket ............................

  // useEffect(() => {
  //   if (socket && value[0] !== "" && messageInput !== '') {
  //     socket.emit("typing", { seller_id: seller, customer_id: customer });
  //     console.log('i am here on typing', value)
  //   }
  // }, [socket, value]);

  // useEffect(() => {
  // const fetchData = async () => {
  //   const demoData = await fetch(
  //     `https://api.scraperapi.com?api_key=1c5af0f8dc3721c33b034e1d13cf99f8&autoparse=true&url=${detectedLink}`
  //   );
  //   const demoDataJson = await demoData.json();
  //   console.log(detectedLink);
  //   console.log(demoDataJson);
  // };
  // fetchData();
  // }, [detectedLink, messageInput]);

  return (
    // ...
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleClick();
      }}
    >
      <div className="messaging-bar">
        {/* {detectedLink && (
          <div className="detected-link h-20">
            <LinkPreview imageHeight={300} external={true} url={detectedLink} />

            <a href={detectedLink}> {detectedLink}</a>
          </div>
        )} */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            gap: "5px",
          }}
        >
          <input
            value={messageInput}
            placeholder="Write message..."
            className="search-input"
            onChange={(e) => {
              const val = e.target.value

              setMessageInput((prev) => {

                if (val.length === 1 && prev.length === 0) {
                  try {
                    socket.emit("typing", { seller_id: seller, customer_id: customer });
                  }
                  catch (error) {
                    console.log('Error emitting typing event')
                  }
                }
                return val
              });
              // const text = e.target.value;
              // const linkRegex = /(https?:\/\/[^\s]+)/g;
              // const matchedLinks = text.match(linkRegex);
              // if (matchedLinks && matchedLinks.length > 0) {
              //   setDetectedLink(matchedLinks[0]);
              // } else {
              //   setDetectedLink(null);
              // }
            }}
            ref={inputRef}
          />

          <button type="Submit" className="message-send-btn">
            Send
            <IoMdSend className="icon" />
          </button>
        </div>
      </div>
    </form>
  );
  // ...
}
